import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { userSettingsFeature } from './state/user-settings.feature';
import { UserSettingsEffects } from './state/user-settings.effects';

export const USER_SETTINGS_STORE_PROVIDERS = {
  feature: provideState(userSettingsFeature),
  effects: provideEffects(UserSettingsEffects),
};
